import React from "react";
import { Row, Col, FormGroup, ControlLabel, FormControl, Alert } from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import LeaveAllocationSummary, { LEAVE_LABELS } from "./LeaveAllocationSummary";

export default function LeaveAllocationEditor({ allocations, balances, onChange, onPreview, preview, loading, error }) {
    const update = (index, field, value) => onChange(allocations.map((row, i) => i === index ? { ...row, [field]: value } : row));
    return (
        <div>
            <h5>Allocate your leave</h5>
            <p>Enter days in the order you want to use them. Scheduled workdays are assigned from the start date, skipping days off and applicable holidays. Use sick leave only for an eligible reason under company policy.</p>
            {allocations.map((row, index) => {
                const balance = balances && balances[row.leaveType];
                const used = allocations.filter(item => item.leaveType === row.leaveType).reduce((sum, item) => sum + (Number(item.days) || 0), 0);
                return (
                    <Row key={index}>
                        <Col sm={5}>
                            <FormGroup controlId={`allocation-type-${index}`}>
                                <ControlLabel>Leave type {index + 1}</ControlLabel>
                                <FormControl componentClass="select" value={row.leaveType} onChange={event => update(index, "leaveType", event.target.value)}>
                                    <option value="">Select leave type</option>
                                    {Object.keys(LEAVE_LABELS).filter(type => type !== "mixed").map(type => (
                                        <option key={type} value={type}>{LEAVE_LABELS[type]}</option>
                                    ))}
                                </FormControl>
                                {balance && <p className="help-block">{balance.availableToRequest} days available · {Number((balance.availableToRequest - used).toFixed(2))} after this request</p>}
                            </FormGroup>
                        </Col>
                        <Col sm={3}>
                            <FormGroup controlId={`allocation-days-${index}`}>
                                <ControlLabel>Days</ControlLabel>
                                <FormControl type="number" min="0.01" step="0.01" value={row.days} onChange={event => update(index, "days", event.target.value)} />
                            </FormGroup>
                        </Col>
                        <Col sm={4}>
                            <Button type="button" simple disabled={allocations.length === 1} onClick={() => onChange(allocations.filter((item, i) => i !== index))} aria-label={`Remove allocation ${index + 1}`}>Remove</Button>
                        </Col>
                    </Row>
                );
            })}
            <Button type="button" disabled={allocations.length >= 100} onClick={() => onChange([...allocations, { leaveType: "", days: "" }])}>Add another leave type</Button>
            <p style={{ marginTop: 15 }}>Total allocated: <strong>{Number(allocations.reduce((sum, row) => sum + (Number(row.days) || 0), 0).toFixed(2))} days</strong>. Allocate every workday, including any time without pay.</p>
            <Button type="button" onClick={onPreview} disabled={loading}>{loading ? "Calculating…" : "Preview dates and balances"}</Button>
            {error && <Alert bsStyle="danger" style={{ marginTop: 15 }} role="alert">{error}</Alert>}
            {preview && (
                <div aria-live="polite">
                    <Alert bsStyle={preview.withoutPayDays ? "warning" : "success"} style={{ marginTop: 15 }}>
                        {preview.requestedDays} workdays: {preview.paidDays} paid and {preview.withoutPayDays} unpaid. Submit this breakdown for one approval.
                    </Alert>
                    <LeaveAllocationSummary allocations={preview.leaveAllocations} days={preview.dayAllocations} />
                </div>
            )}
            {!preview && <p className="help-block">Preview the dates and balances before submitting.</p>}
        </div>
    );
}
